import type {RepoPaths} from '../types'

/** Derive all URL paths from owner + repo name instead of receiving them from Rails. */
export function deriveRepoPaths(ownerLogin: string, repoName: string): RepoPaths {
  const repoUrl = `/${ownerLogin}/${repoName}`
  return {
    ownerProfilePath: `/${ownerLogin}`,
    repoUrl,
    repoNameWithOwner: `${ownerLogin}/${repoName}`,
    starPath: `${repoUrl}/star`,
    unstarPath: `${repoUrl}/unstar`,
    forkSelectPath: `${repoUrl}/fork`,
    forksApiPath: `${repoUrl}/my_forks_menu_content`,
    templatePath: `${repoUrl}/generate`,
    listsApiPath: `${repoUrl}/_header/lists`,
    listsUpdatePath: `${repoUrl}/lists`,
    branchesPath: `${repoUrl}/branches`,
    tagsPath: `${repoUrl}/tags`,
  }
}
